"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ahooks = require("ahooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../_util/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SkeletonNode = props => {
  const {
    loading = true,
    active = true,
    radius = true,
    block,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-skeletonNode");
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  const ref = (0, _react.useRef)(null);
  const size = (0, _ahooks.useSize)(ref);
  if (children === false || children === null || children === undefined) {
    return null;
  }

  //32 + 16 = 48 * 2 = 96
  const hasBar = !!(size !== null && size !== void 0 && size.height) && size.height > 96 - 16;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...attrs.data,
    ref: ref,
    className: (0, _classnames.default)(className, baseClassName, {
      block,
      loading,
      active: loading && active,
      radius: loading && radius,
      hasBar: loading && hasBar
    }),
    style: style,
    children: [loading && hasBar && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "bar",
      children: new Array(Math.floor((size.height + 16) / 48)).fill(undefined).map((_, key) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames.default)('bar-item', {
          active,
          radius
        })
      }, key))
    }), children]
  });
};
var _default = exports.default = SkeletonNode;